import { ProviderServiceModel } from "../../../entities";
import { BaseODataRepository } from "../../BaseODataRepository";

export class ProviderServiceODataRepo extends BaseODataRepository<ProviderServiceModel> {
  protected baseUrl = `/OData/providerservices`;
}
